import { SignupController } from './signup.controller';

export default SignupController;
export { SignupWithLinkController } from './features';
